import React, { useEffect, useState } from "react";
import PlusIcon from "../../assets/icons/plus";
import api from "../../setupMiddleware";
import Loader from "../Loader/Loader";
import useApiLoader from "../../Utils/useApiLoader";
import { Link } from "react-router-dom";
import Popup from "../Common/Popup";
import { hasPermission, isAdmin } from "../../Utils/auth";
import TeamMemberTable from "../Common/TeamMemberTable";

const TeamEmployee = () => {
  const loading = useApiLoader();
  const [empData, setEmpData] = useState([]);
  const [designationData, setDesignationData] = useState([]);
  const [apiErrorOpen, setApiErrorOpen] = useState(false);

  const designationOptions = [
    { label: "All Designations", value: "" },
    ...(designationData?.map((des) => ({
      label: des.title,
      value: des.id,
    })) || []),
  ];

  const getAllUser = async () => {
    api.get("/api/team-members").then((res) => {
      if (res && res.status === 200) {
        setEmpData(res.data?.data);
      }
    });
  };

  const getAllDesignations = async () => {
    api.get("/api/designations").then((res) => {
      if (res && res.status === 200) {
        setDesignationData(res.data);
      }
    });
  };

  useEffect(() => {
    getAllUser();
    getAllDesignations();
  }, []);

  return (
    <>
      {loading && <Loader opacity={90} fullscreen />}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center w-full mx-auto px-4 py-3 gap-4">
        {/* Left Content */}
        <p>
          <span className="block text-xl sm:text-2xl font-medium text-[#de2b26]">
            Team Employees
          </span>
          <span className="block text-sm text-[#142b70]/50">
            View Team members detail
          </span>
        </p>
      </div>
      <div className="w-full mx-auto px-4 py-3 relative">
        <div className="w-full mx-auto px-4 py-3 relative rounded-xl bg-white border border-[#a48572]/10">
          <div className="flex flex-col justify-start items-start gap-[20px]">
            <div className="flex flex-col justify-start items-start flex-grow-0 flex-shrink-0 relative gap-5">
              <p className="flex-grow-0 flex-shrink-0 text-base font-medium text-left text-[#142b70]">
                All Employees
              </p>
            </div>
            <TeamMemberTable
              data={empData}
              designationOptions={designationOptions}
            />
          </div>
        </div>
      </div>
      <Popup
        isOpen={apiErrorOpen}
        onClose={() => setApiErrorOpen(false)}
        title="Error"
      >
        <div className="flex flex-col gap-6 mt-[30px] mb-[30px]">
          <div className="flex flex-col gap-2">
            <p className="text-sm text-[#142b70]/80 text-left">
              Something went wrong! Please try again later.
            </p>
          </div>
        </div>

        <div className="flex justify-end gap-4">
          <button
            onClick={() => setApiErrorOpen(false)}
            className="px-10 py-3.5 rounded-md bg-[#de2b26] text-white font-medium disabled:opacity-50"
          >
            Ok
          </button>
        </div>
      </Popup>
    </>
  );
};

export default TeamEmployee;
